var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 19,
  viewBox: "0 0 17 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.278 0c.737 0 .904 1.198.904 2.329 0 2.326-2.18 3.891-2.18 3.891L17 7.603s-.565 3.721-.953 4.997c-.675 2.215-2.237 5.476-2.237 5.476L4.112 16.48V7.177s1.356-.731 3.849-2.556c1.25-.648 2.417-1.475 3.354-2.404C12.246 1.293 12.95 0 13.278 0M3 7v9.5H0V7z"
})));
export default SvgYoutubeDesktopLike;